var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmallB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.756 0.25237C10.4306 -0.0729994 9.90501 -0.0729994 9.57964 0.25237L5.5 4.32366L1.42036 0.244027C1.09499 -0.0813424 0.569397 -0.0813424 0.244027 0.244027C-0.0813424 0.569397 -0.0813424 1.09499 0.244027 1.42036L4.32366 5.5L0.244027 9.57964C-0.0813424 9.90501 -0.0813424 10.4306 0.244027 10.756C0.569397 11.0813 1.09499 11.0813 1.42036 10.756L5.5 6.67634L9.57964 10.756C9.90501 11.0813 10.4306 11.0813 10.756 10.756C11.0813 10.4306 11.0813 9.90501 10.756 9.57964L6.67634 5.5L10.756 1.42036C11.073 1.10334 11.073 0.569397 10.756 0.25237Z",
    fill: "#263CAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmallB);
export default __webpack_public_path__ + "static/media/CloseSmallB.8ab1103dd2bbd6fa90fabcd39ab61df3.svg";
export { ForwardRef as ReactComponent };